import axios from "axios";
import { CHECKOUT_URL, LOGIN_CHECKOUT_URL } from "@/utils/api/Urls";

/**
 * Fetches checkout details from the server based on the provided checkout ID.
 * @param id The ID of the checkout to fetch.
 * @returns The checkout details of the specified checkout.
 * @throws Error if the checkout is not found (404)
 */
export const fetchCheckoutById = async (id: number) => {
  const requestURL = `${LOGIN_CHECKOUT_URL}${CHECKOUT_URL}/${id}`;

  try {
    const response = await axios.get(requestURL);
    return response.data;
  } catch (err: unknown) {
    // Axios error
    if (axios.isAxiosError(err)) {
      // The request was made and the server responded with a status code
      if (err.response) {
        if (err.response.status === 404) {
          throw new Error("Checkout not found");
        }
        console.log("Error status:", err.response.status);
        return;
      }

      // The request was made but no response was received
      if (err.request) {
        console.log("No response received from server:", err.request);
        return;
      }
    }

    // Non-Axios error
    console.log("Non-Axios error occurred:", err);
  }
};
